import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  SuppressedDomain,
  SuppressedDomainsResponse,
  UpdateSuppressedDomainsRequest,
} from './types/suppressed-domains.type';

export const suppressedDomainsService = (client: AxiosInstance) => {
  const SUPPRESSED_DOMAINS_BASE_URL = '/gophish/settings/suppressed-domains';

  const getSuppressedDomains = async (): Promise<SuppressedDomainsResponse> => {
    try {
      const result = await client.get<
        SuppressedDomainsResponse,
        AxiosResponse<SuppressedDomainsResponse>
      >(SUPPRESSED_DOMAINS_BASE_URL, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updateSuppressedDomainsList = async (
    request: UpdateSuppressedDomainsRequest,
  ): Promise<SuppressedDomain> => {
    try {
      const result = await client.put<
        SuppressedDomain,
        AxiosResponse<SuppressedDomain>
      >(SUPPRESSED_DOMAINS_BASE_URL, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getSuppressedDomains,
    updateSuppressedDomainsList,
  };
};
